var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import { createComponent } from '@cloudflare/style-container';
import clearRenderer from './clearRenderer';

var CloseMenuComponent = function (_React$Component) {
  _inherits(CloseMenuComponent, _React$Component);

  function CloseMenuComponent(props) {
    _classCallCheck(this, CloseMenuComponent);

    var _this = _possibleConstructorReturn(this, (CloseMenuComponent.__proto__ || Object.getPrototypeOf(CloseMenuComponent)).call(this, props));

    _this.handleTouchDown = function () {
      return _this.dragging = true;
    };
    _this.handleTouchMove = function () {
      return _this.dragging = false;
    };
    _this.handleTouchEnd = function () {
      if (!_this.dragging) {
        _this.props.closeMenu();
      }
    };
    return _this;
  }

  _createClass(CloseMenuComponent, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'span',
        {
          className: this.props.className,
          onMouseDown: this.props.closeMenu,
          onTouchStart: this.handleTouchStart,
          onTouchMove: this.handleTouchMove,
          onTouchEnd: this.handleTouchEnd,
          role: 'button',
          tabIndex: 0
        },
        clearRenderer()
      );
    }
  }]);

  return CloseMenuComponent;
}(React.Component);

CloseMenuComponent.propTypes = {
  closeMenu: PropTypes.func.isRequired,
  className: PropTypes.string
};

var CloseMenu = createComponent(function () {
  return {
    cursor: 'pointer',
    float: 'right'
  };
}, CloseMenuComponent);
CloseMenu.setDisplayName('CloseMenu');

export default CloseMenu;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-select/es/CloseMenu.js
// module id = 1111
// module chunks = 1